import React, { useMemo } from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { handleDetailSteamsalesFilterParamsToApi, } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import SteamSalesContext from './index';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';

export default function DigitalRevenue(props: any) {
  const {
  } = props;

  const defaultFilterValue = useMemo(() => ({
    [filterKeyMap.RANGE_TIME]: {
      type: 'month',
      value: ['', ''],
    },
  }), []);

  const filterCfg: TopchartFilterCfgType = useMemo(() => ({
    filterKeyList: [
      filterKeyMap.RANGE_TIME,
    ],
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions: [], // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: false,
      rangeTimeType: FilterTimeType.commonRange,
      isShowAlloftime: false,
      showShortcut: true,
    },
    showConfirmButton: false,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleDetailSteamsalesFilterParamsToApi,
  }), [defaultFilterValue,]);

  return (
    <SteamSalesContext
      {...props}
      filterCfg={filterCfg}
    />
  );
}
